import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Menu from './pages/Menu';
import MenuFilter from './pages/MenuFilter';
import Login from './pages/Login';
import Newproduct from './pages/Newproduct';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import Cart from './pages/Cart';
import Success from './pages/Success';
import Cancel from './pages/Cancel';
import { createBrowserRouter,createRoutesFromElements, Route, RouterProvider} from 'react-router-dom';
import { store } from "./redux/index";
import { Provider } from 'react-redux';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import Orders from './pages/Orders';
import AdminOrders from './pages/AdminOrders';
import OfferManagement from './pages/OfferManagement';
import AdminMessages from './pages/AdminMessages';
import Gallery from './pages/Gallery';
import AdminGallery from './pages/AdminGallery';
import UserMessages from './pages/UserMessages';
import NotFound from './pages/NotFound';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminUsers from './pages/AdminUsers';
import ManageCategories from './pages/ManageCategories';

const router=createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App/>}>
      <Route index element={<Home/>}/>
      <Route path='menu' element={<Menu/>}/>  {/*--will decide */}
      <Route path='menu/:category' element={<Menu/>}/>
      <Route path='about' element={<About/>}/>
      <Route path='contact' element={<Contact/>}/>
      <Route path='login' element={<Login/>}/>
      <Route path='newproduct' element={<Newproduct/>}/>
      <Route path='signup' element={<Signup/>}/>
      <Route path='verify-email' element={<VerifyEmail/>}/>
      <Route path='forgot-password' element={<ForgotPassword/>}/>
      <Route path='reset-password' element={<ResetPassword/>}/>
      <Route path='cart' element={<Cart/>}/>
      <Route path='success' element={<Success/>}/>
      <Route path='profile' element={<Profile/>}/>
      <Route path='cancel' element={<Cancel/>}/>
      <Route path='privacy-policy' element={<PrivacyPolicy/>}/>
      <Route path='TermsConditions' element={<TermsConditions/>}/>
      <Route path='orders' element={<Orders/>}/>
      <Route path='my-messages' element={<UserMessages/>}/>
      <Route path='manage' element={<AdminOrders/>}/>
      <Route path='offer-management' element={<OfferManagement/>}/>
      <Route path='admin-messages' element={<AdminMessages/>}/>
      <Route path='gallery' element={<Gallery/>}/>
      <Route path='admin-gallery' element={<AdminGallery/>}/>
      <Route path='admin-users' element={<AdminUsers/>}/>
      <Route path='admin-categories' element={<ManageCategories/>}/>
      <Route path='*' element={<NotFound/>}/>


    </Route>
  )
)
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
      <HelmetProvider>
         <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            <RouterProvider router={router}/>
         </GoogleOAuthProvider>
      </HelmetProvider>
  </Provider>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
